import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 755.907 755.907"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M748 323V191zH639.32A200 200 0 0 1 747 503v62a90 94 0 0 1-366 0h52.132V433.607h130.11V323.51h-130.11V191.047H380.27A185 210 0 0 1 748 191m-425.598 0v132.51H190.417v110.097H322V565h52v190H175.837A185 210 0 0 1 8 543V191a184 210 0 0 1 365 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }